export enum ActionMode {
  CART = 'cart',
  LENSES = 'lenses'
}

export enum Section {
  description = 'sectionDescription',
  technical = 'technicalSection',
  insurance = 'sectionInsurance',
  availability = 'sectionAvailability',
}

export enum ProductDetailsMode {
  details = 'productDetails',
  added = 'productAdded'
}
